const commercial = {
  commercial: {
    pageHeader: '商業プロジェクト',
    pageSubHeading: 'Enphaseのデジタルツールおよびサービスは、お客様の商用フリートを作成および管理します。',
    contactUsMessage: '商業サービスに関するお問い合わせ先',
    contactUsEmail: 'メール',
    contactUsPhone: '電話',
    contactUsHelpText: 'さらにサポートが必要ですか？',
    contactUsRedirectText: 'こちらをクリック',
    bomFormTitle: 'BOM計算',
    bomFormText: '次に進むには、いずれかのオプションを選択してください',
    bomFormNewBomOption: '新しい部品表（BOM）を計算する',
    bomFormExistingBomOption: '既存の部品表（BOM）を開く/編集する',
    leadCardTitle: 'My Leads',
    leadCardDesc: '商業用リードの作成と管理',
    systemCardTitle: 'システム',
    systemCardDesc: '商用サイトの作成とフリートのモニタリング',
    bomCardTitle: 'BOM計算',
    bomCardDesc: 'BOM（部品表）とプロジェクトコストの見積もり',
    solargrafCardTitle: '設計・提案ツール（Solargraf）',
    solargrafCardDesc: '包括的な設計・提案ツールへのアクセス',
    resourceCardTitle: 'リソース',
    resourceCardDesc: 'リソースにアクセスしてEnphaseのコマーシャルの詳細をご覧ください',
    commResourceTitle: '商用リソース',
    commResourceDesc: 'すべての商用リソースにアクセス',
    euResourceTitle: 'Enphase University（トレーニング）',
    euResourceDesc: 'Enphaseによる商用トレーニングにアクセス',
    mccResourceTitle: 'モジュール互換性計算機',
    mccResourceDesc: 'Enphaseマイクロインバーターとのモジュールの互換性を判断',
    serviceCardTitle: '商業サービス',
    serviceCardDesc: '商用サイトのサービスにアクセス',
    drsServiceTitle: 'デザイン・レビュー・サービス',
    drsServiceDesc: '商用サイトのデザインをレビューしてもらう',
    permitServiceTitle: '許可支援サービス',
    permitServiceDesc: '商用サイトの許可支援を受ける',
    contactCardTitle: 'お問い合わせ',
    contactCardDesc: 'どのような段階でも喜んでお手伝いいたします'
  }
};

export default commercial;
